export const userConstants = {
    LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
    LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
    LOGIN_FAILURE: 'USERS_LOGIN_FAILURE',

    REGISTER_REQUEST: 'USERS_REGISTER_REQUEST',
    REGISTER_SUCCESS: 'USERS_REGISTER_SUCCESS',
    REGISTER_FAILURE: 'USERS_REGISTER_FAILURE',

    LOGOUT: 'USERS_LOGOUT',

    SET_DEFAULT_EVENT_REQUEST:'SET_DEFAULT_EVENT_REQUEST',
    SET_DEFAULT_EVENT_SUCCESS:'SET_DEFAULT_EVENT_SUCCESS',
    SET_DEFAULT_EVENT_FAILURE:'SET_DEFAULT_EVENT_FAILURE',

    GETALL_REQUEST: 'USERS_GETALL_REQUEST',
    GETALL_SUCCESS: 'USERS_GETALL_SUCCESS',
    GETALL_FAILURE: 'USERS_GETALL_FAILURE',

    GET_ACCOUNT_DETAILS_REQUEST: 'GET_ACCOUNT_DETAILS_REQUEST',
    GET_ACCOUNT_DETAILS_SUCCESS: 'GET_ACCOUNT_DETAILS_SUCCESS',
    GET_ACCOUNT_DETAILS_FAILURE: 'GET_ACCOUNT_DETAILS_FAILURE',

    UPDATE_REQUEST: 'USERS_UPDATE_REQUEST',
    UPDATE_SUCCESS: 'USERS_UPDATE_SUCCESS',
    UPDATE_FAILURE: 'USERS_UPDATE_FAILURE',
    TOGGLE_ADMIN_REQUEST:'TOGGLE_ADMIN_REQUEST',
    TOGGLE_ADMIN_SUCCESS:'TOGGLE_ADMIN_SUCCESS',
    TOGGLE_ADMIN_FAILURE:'TOGGLE_ADMIN_FAILURE',

    
    SENDRESETPASSWORDTOKEN_REQUEST: 'SENDRESETPASSWORDTOKEN_REQUEST',
    SENDRESETPASSWORDTOKEN_SUCCESS: 'SENDRESETPASSWORDTOKEN_SUCCESS',
    SENDRESETPASSWORDTOKEN_FAILURE: 'SENDRESETPASSWORDTOKEN_FAILURE',

    
    RESETPASSWORD_REQUEST: 'RESETPASSWORD_UPDATE_REQUEST',
    RESETPASSWORD_SUCCESS: 'RESETPASSWORD_UPDATE_SUCCESS',
    RESETPASSWORD_FAILURE: 'RESETPASSWORD_UPDATE_FAILURE'
};